// src/components/BookingsPage.js
import React, { useEffect, useState } from "react";
import {
  collection, getDocs, doc, getDoc, updateDoc, deleteDoc
} from "firebase/firestore";
import { db } from "../firebase";

export default function BookingsPage() {
  const [bookings, setBookings] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);

  const loadBookings = async () => {
    const snap = await getDocs(collection(db, "bookings"));
    setBookings(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => {
    loadBookings();
  }, []);

  const filtered = bookings.filter((b) =>
    `${b.fullName} ${b.phone} ${b.desiredRoom}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const approveBooking = async (id) => {
    await updateDoc(doc(db, "bookings", id), { status: "Approved" });
    loadBookings();
  };

  const rejectBooking = async (id) => {
    await updateDoc(doc(db, "bookings", id), { status: "Rejected" });
    loadBookings();
  };

  const setPendingBooking = async (id) => {
    await updateDoc(doc(db, "bookings", id), { status: "Pending" });
    loadBookings();
  };
    
  const deleteBooking = async (id) => {
    if (window.confirm("Delete this booking?")) {
      await deleteDoc(doc(db, "bookings", id));
      loadBookings();
    }
  };

  const formatDate = (v) => {
    if (!v) return "—";
    if (typeof v === "string") return v;
    if (v.toDate) return v.toDate().toLocaleDateString();
    return "—";
  };

  return (
    <div className="space-y-6">

      {/* Header */}
      <h1 className="text-2xl font-bold">Bookings</h1>

      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search name / phone / room"
        className="border p-2 rounded w-72 mb-4"
      />

      {/* Table */}
      <div className="bg-white/95 border border-amber-50 rounded-xl shadow-md overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead className="bg-orange-50">
            <tr>
              {[
                "Full Name", "Phone", "Dept", "Room",
                "Arrival", "Departure", "Status", "Actions"
              ].map((h) => (
                <th key={h} className="p-3 text-left font-semibold text-gray-700">
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {filtered.map((b) => (
              <tr key={b.id} className="hover:bg-orange-50/40">
                <td className="p-3">{b.fullName}</td>
                <td className="p-3">{b.phone}</td>
                <td className="p-3">{b.facultyDept}</td>
                <td className="p-3">{b.desiredRoom}</td>
                <td className="p-3">{formatDate(b.arrivalDate)}</td>
                <td className="p-3">{formatDate(b.departureDate)}</td>
                <td className="p-3">
                  <span
                    className={`px-2 py-1 text-xs rounded text-white ${
                      b.status === "Approved"
                        ? "bg-green-600"
                        : b.status === "Rejected"
                        ? "bg-red-600"
                        : "bg-yellow-600"
                    }`}
                  >
                    {b.status}
                  </span>
                </td>

                <td className="p-3 space-x-3">
                  <button
                    className="text-[#b4642d]"
                    onClick={() => setSelected(b)}
                  >
                    View
                  </button>

                  <button
                    className="text-green-600"
                    onClick={() => approveBooking(b.id)}
                  >
                    Approve
                  </button>

                  <button
                    className="text-yellow-600"
                    onClick={() => setPendingBooking(b.id)}
                  >
                    Pending
                  </button>

                  <button
                    className="text-red-600"
                    onClick={() => rejectBooking(b.id)}
                  >
                    Reject
                  </button>

                  <button
                    className="text-red-600"
                    onClick={() => deleteBooking(b.id)}
                  >
                    Delete
                  </button>
                </td>


              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* View Modal */}
      {selected && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center">
          <div className="bg-white/95 border border-amber-50 rounded-xl p-6 w-[450px] shadow-lg">
            <h2 className="text-xl font-bold mb-4">Booking Details</h2>

            <div className="space-y-2 text-sm">
              {[
                ["Name", selected.fullName],
                ["Phone", selected.phone],
                ["Email", selected.email],
                ["Dept", selected.facultyDept],
                ["Gender", selected.gender],
                ["Passport ID", selected.passportId],
                ["Arrival", formatDate(selected.arrivalDate)],
                ["Departure", formatDate(selected.departureDate)],
                ["Room", selected.desiredRoom],
                ["Guarantor", selected.guarantor],
                ["Next of Kin", selected.nextOfKin],
                ["Payment", selected.paymentOption],
                ["Notes", selected.notes || "None"],
              ].map(([label, value]) => (
                <p key={label}>
                  <strong>{label}:</strong> {value}
                </p>
              ))}
            </div>

            <div className="mt-6 text-right">
              <button
                className="px-4 py-2 bg-gray-300 rounded"
                onClick={() => setSelected(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
